import React from "react";
import RodCutting from "components/comp/RodCutting";
import GoRodCutting from "components/comp/GoRodCutting";

// why: 기존 RodCuttingAlgo 페이지를 제품소개 하위 전용 경로로 재노출

const ProductRodCutting = () => {
  return (
    <main className="page-sub">
      <section className="company-main">
        <RodCutting/>
        <div className="btn-container">
          <GoRodCutting/>
        </div>
      </section>
    </main>
  );
};

export default ProductRodCutting;


